.ju{right:0.25rem;}